<template>
  <b-modal
    :visible="value"
    :title="modalTitle"
    size="md"
    hide-footer
    centered
    @change="modalChangeEvent"
  >
    <BfInput
      :value="formData.titulo"
      data-key="titulo"
      :label="nameFieldLabel"
      :placeholder="nameFieldPlaceholder"
      :errors="formErrors"
      @update="updateForm"
    />

    <BfSelect
      :value="formData.categoria"
      data-key="categoria"
      label="Categoría"
      :errors="formErrors"
      :options="categorySelectOptions"
      @update="updateForm"
    />

    <div v-if="formattedErrors" class="mt-2">
      <p class="text-danger" v-html="formattedErrors" />
    </div>

    <div v-if="isUploading" class="progress-bar-wrap">
      <UploadProgressBar
        :size-progress="uploadSizeProgress"
        :count-progress="uploadCountProgress"
      />
    </div>

    <div class="mt-4 text-right">
      <BfButton
        variant="secondary"
        class="mr-3"
        @click="modalChangeEvent(false)"
      >
        Cancelar
      </BfButton>
      <BfButton @click="saveFormData" :disabled="disableSaveButton">
        {{saveButtonLabel}}
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
import get from 'lodash.get';
import UploadProgressBar from '@/components/UploadProgressBar';

export default {
  name: 'FileFormModal',

  props: {
    categories: {
      type: Array,
      default: () => [],
    },

    initialFormData: {
      type: Object,
      default: () => {},
    },

    isEditing: {
      type: Boolean,
      default: false,
    },

    isUploading: {
      type: Boolean,
      default: false,
    },

    formErrors: {
      type: Object,
    },

    multipleFiles: {
      type: Boolean,
      default: false,
    },

    uploadSizeProgress: Object,

    uploadCountProgress: Object,

    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: this.initialFormData,
    };
  },

  methods: {
    updateForm({ key, value }) {
      this.formData = {
        ...this.formData,
        [key]: value,
      };
    },

    modalChangeEvent(visible) {
      this.formData = !visible ? {} : this.initialFormData;
      this.$emit('input', visible);
    },

    saveFormData() {
      this.$emit('save-data', this.formData);
    },
  },

  computed: {
    categorySelectOptions() {
      return this.categories.map((label, index) => ({
        label,
        value: index,
      }));
    },

    disableSaveButton() {
      if (this.isUploading) {
        return true;
      }

      const filename = get(this.formData, ['titulo'], null);
      const selectedCat = get(this.formData, ['categoria'], null);

      return selectedCat === null || (!filename && !this.multipleFiles);
    },

    formattedErrors() {
      if (!this.formErrors || (this.formErrors && !Object.keys(this.formErrors).length)) {
        return null;
      }

      return Object.keys(this.formErrors)
        .filter(key => ['titulo', 'categoria'].indexOf(key) === -1)
        .map((key) => {
          const errors = this.formErrors[key] || [];

          return errors.join('<br />');
        })
        .join('<br />');
    },

    modalTitle() {
      if (this.isEditing) {
        return 'Editar Documento';
      }

      return `Subir Documento${this.multipleFiles ? 's' : ''}`;
    },

    saveButtonLabel() {
      return `Guardar Fichero${this.multipleFiles ? 's' : ''}`;
    },

    nameFieldLabel() {
      return !this.multipleFiles ? 'Nombre' : 'Prefijo';
    },

    nameFieldPlaceholder() {
      return !this.multipleFiles
        ? 'Escribe el nombre del fichero'
        : 'Escribe el prefijo que quieras aplicar a varios ficheros';
    },
  },

  watch: {
    initialFormData(newData) {
      this.formData = newData;
    },
  },

  components: {
    UploadProgressBar,
  },
};
</script>

<style lang="scss" scoped>
.category-checkbox /deep/ .bf-label-wrap {
  display: none;
}

.progress-bar-wrap {
  display: flex;
  justify-content: flex-end;
}
</style>
